
import React from 'react';
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';
import { UnitSystem } from '@/utils/unitConversion/types';

interface UnitToggleProps {
  value: UnitSystem;
  onValueChange: (value: UnitSystem) => void;
}

const UnitToggle: React.FC<UnitToggleProps> = ({ value, onValueChange }) => {
  return (
    <ToggleGroup type="single" value={value} onValueChange={onValueChange} size="sm">
      <ToggleGroupItem value="metric" aria-label="Toggle metric units">
        Metric
      </ToggleGroupItem>
      <ToggleGroupItem value="imperial" aria-label="Toggle imperial units">
        Imperial
      </ToggleGroupItem>
    </ToggleGroup>
  );
};

export default UnitToggle;
